// extracted by mini-css-extract-plugin
export var label = "_ie-2";
export var slideContainer = "_ie-0";
export var slider = "_ie-1";